<template>
  <div>
    <filter-card :get-report="getReport" />
    <b-card no-body>
      <report-table />
      <report-income-table />
      <b-card-body v-if="loading">
        <pre-loading />
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import { BCard, BCardBody } from 'bootstrap-vue'
import ReportTable from '@/views/Admin/Reports/Safes/components/ReportTable.vue'
import ReportIncomeTable from '@/views/Admin/Reports/Safes/components/ReportIncomeTable.vue'
import FilterCard from '@/views/Admin/Reports/Safes/components/FilterCard.vue'
import PreLoading from '@/layouts/components/common/PreLoading.vue'

export default {
  name: 'IndexPage',
  components: {
    BCard,
    BCardBody,
    ReportTable,
    ReportIncomeTable,
    FilterCard,
    PreLoading,
  },
  computed: {
    dataList() {
      return this.$store.getters['safesReports/dataList']
    },
    filterParams() {
      return this.$store.getters['safesReports/filterParams']
    },
    loading() {
      return this.$store.getters['safesReports/loading']
    },
  },
  created() {
    this.getReport()
  },
  methods: {
    getReport() {
      this.getReportData()
      this.getIncomeReport()
    },
    getReportData() {
      this.$store.dispatch('safesReports/getReport', this.filterParams)
    },
    getIncomeReport() {
      this.$store.dispatch('safesReports/getIncomeReport', this.filterParams)
    },
  },
}
</script>
